export default __webpack_public_path__ + "static/media/checker1.afc36d70.jpg";